import React, { useEffect } from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { KeyboardProvider } from "react-native-keyboard-controller";
import RootNavigator from "./src/RootNavigator";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./src/redux/store";
import "./src/gesture-handler/gesture-handler";
import "./src/i18n";
import { LogBox, StatusBar } from "react-native";
import { initializeNotificationHandlers } from "./src/services/notifications/notificationService";
import updateService from "./src/services/updateService";

LogBox.ignoreLogs([
  "Non-serializable values were found in the navigation state.",
  "Sending `onAnimatedValueUpdate` with no listeners registered.",
]);

const App = () => {
  useEffect(() => {
    return initializeNotificationHandlers();
  }, []);

  useEffect(() => {
    // Initialize update service and check for updates on app start
    const initializeUpdates = async () => {
      try {
        if (updateService.isUpdatesEnabled()) {
          console.log("Updates enabled, checking for available updates...");
          await updateService.checkForUpdates();
        } else {
          console.log("Updates are not enabled");
        }
      } catch (error) {
        console.error("Failed to initialize updates:", error);
      }
    };

    initializeUpdates();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SafeAreaProvider>
          <KeyboardProvider>
            <RootNavigator />
            <StatusBar barStyle="dark-content" />
          </KeyboardProvider>
        </SafeAreaProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
